export const License = {
  methods: {
    License(vehicle, alpha) {
      return `            
          <strong>
            <span>${vehicle.substring(7, 9)}</span>
            <span class="text-blue-500 mx-1 font-bold">|</span>
            <span>${vehicle.substring(4, 7)}</span>
            <span class="mx-1">
              ${
                alpha.find((i) => i.code == vehicle.substring(2, 4)) !=
                undefined
                  ? alpha.find((i) => i.code == vehicle.substring(2, 4)).char
                  : ""
              }
            </span>
            <span>${vehicle.substring(0, 2)}</span>
          </strong>          
          `;
    },
  },
};
